import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { BoxWithRibbon } from "../BoxWithRIbbon";

const SuccessMessage = () => {
    const { getMultiple } = useMicrocopy();

    const microcopies = (() => {
        return getMultiple(CommonCMS.page, [CommonCMS.loyalty.thankYouForJoining]);
    })();

    return (
        <BoxWithRibbon>
            <Box paddingBottom={[2, 4, 6]}>
                <Text>{microcopies[CommonCMS.loyalty.thankYouForJoining]}</Text>
            </Box>
        </BoxWithRibbon>
    );
};

export default SuccessMessage;
